<template>
  <div class="flex flex-row align-items-center ml-3 mt-3 mb-1">
    <i class="pi pi-user mr-3" style="font-size: 2.5rem"></i>
    <h2 class="font-medium" v-if="employee">
      {{ employee?.code }} {{ employee?.name }}
    </h2>
    <Skeleton v-else class="w-3"></Skeleton>
  </div>
  <Divider />
  <Fieldset class="w-11" :toggleable="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="font-medium">Datos personales</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Cédula</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.identificationNumber
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Estado civil</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.maritalStatus
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Nacionalidad</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.nationality
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Licencia de conducir</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.driverLicenseType
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Tipo de sangre</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.bloodType
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Género</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.gender
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de nacimiento</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ formattedBirthDate }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium"> N° Seguro Social</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.socialSecurityNumber }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Datos familiares</label>
          <i
            class="pi pi-eye text-blue-800 mt-2 cursor-pointer"
            style="font-size: 1.5rem"
            @click="seeRelatives = true"
          ></i>
        </div>
      </div>
      <!--add payrolls modal-->
      <Dialog
        v-model:visible="seeRelatives"
        modal
        header="Datos familiares"
        :style="{ width: '50vw' }"
        :breakpoints="{ '960px': '75vw', '641px': '100vw' }"
      >
        <DataTable
          style="width: 99%"
          scrollable
          scrollHeight="500px"
          :value="employee?.EmployeeRelatives"
          dataKey="code"
          tableStyle="min-width: 50rem"
          :globalFilterFields="['name']"
        >
          <template #empty> No se encontraron familiares. </template>
          <Column field="fullName" header="Nombre"></Column>
          <Column field="identificationNumber" header="ID"></Column>
          <Column field="address" header="Dirección"></Column>
          <Column field="phone" header="Telefono"></Column>
          <Column field="relationshipType" header="Parentesco"></Column>
          <Column field="isDisability" header="Discapacitado">
            <template #body="slotProps">
              <span v-if="slotProps.data.isDisability">Si</span>
              <span v-else>No</span>
            </template>
          </Column>
          <Column field="isDependent" header="Dependiente">
            <template #body="slotProps">
              <span v-if="slotProps.data.isDependent">Si</span>
              <span v-else>No</span>
            </template>
          </Column>
          <Column field="isStudent" header="Estudiante">
            <template #body="slotProps">
              <span v-if="slotProps.data.isStudent">Si</span>
              <span v-else>No</span>
            </template>
          </Column>
        </DataTable>
        <template #footer>
          <Button
            label="Cerrar"
            icon="pi pi-times"
            @click="seeRelatives = false"
          />
        </template>
      </Dialog>
    </div>
  </Fieldset>
  <Divider></Divider>
  <Fieldset class="w-11" :toggleable="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="font-medium">Datos de contacto</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">País de residencia</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.countryResidence
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Ciudad</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.cityResidence
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Dirección domiciliar</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.addressLocation
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Teléfono primario</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.primaryPhone
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Teléfono secundario</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.secondaryPhone
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Código postal</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.postalCode
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
    </div>
  </Fieldset>
  <Divider></Divider>
  <Fieldset class="w-11 mb-5" :toggleable="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="font-medium">Datos laborales</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Empresa</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.company
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Sucursal</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.subsidiary
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Dirección</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.direction
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Gerencia</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.management
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Departamento</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.department
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Area</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.area
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Cargo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.position
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Turno</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.shift
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de ingreso</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            formattedJoiningDate
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Causa de ingreso</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.joiningReason
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Supervisor</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.supervisor?.fullname
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Día(s) teletrabajo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.remoteDays
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Sueldo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            formattedSalaryAmount
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Moneda</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.currency
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Base de sueldo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.salaryBase
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
    </div>
  </Fieldset>
</template>
<script setup lang="ts">
  import { useUserStore } from '@/store'
  import { storeToRefs } from 'pinia'
  import { computed, onMounted, ref } from 'vue'
  import { EmployeeDetail } from '../models/EmployeeDetail'
  import { getEmployeeById } from '../services/EmployeeService'
  import Divider from 'primevue/divider'
  import moment from 'moment'

  const { user, company } = storeToRefs(useUserStore())
  const employee = ref<EmployeeDetail>()
  const seeRelatives = ref(false)

  onMounted(() => {
    if (user.value?.employeeId) {
      getEmployeeById(user.value?.employeeId).then(
        (response) => (employee.value = response)
      )
    }
  })

  const formattedBirthDate = computed(() => {
    if (employee.value?.birthDate) {
      return moment.utc(employee.value.birthDate).format('DD/MM/YYYY')
    }
    return ''
  })

  const formattedJoiningDate = computed(() => {
    if (employee.value?.joiningDate) {
      return moment.utc(employee.value.joiningDate).format('DD/MM/YYYY')
    }
    return ''
  })

  const formattedSalaryAmount = computed(() => {
    let salaryAmountString = employee.value?.salaryAmount
    return salaryAmountString
  })
</script>
